__turbopack_context__.v({
  "bg-lg-background": "Y1zP0a_bg-lg-background",
  "bg-lg-black": "Y1zP0a_bg-lg-black",
  "bg-lg-danger": "Y1zP0a_bg-lg-danger",
  "bg-lg-dangerLight": "Y1zP0a_bg-lg-dangerLight",
  "bg-lg-dangerVeryLight": "Y1zP0a_bg-lg-dangerVeryLight",
  "bg-lg-default": "Y1zP0a_bg-lg-default",
  "bg-lg-facebook": "Y1zP0a_bg-lg-facebook",
  "bg-lg-featured": "Y1zP0a_bg-lg-featured",
  "bg-lg-featuredLight": "Y1zP0a_bg-lg-featuredLight",
  "bg-lg-featuredVeryLight": "Y1zP0a_bg-lg-featuredVeryLight",
  "bg-lg-focus-ring-color": "Y1zP0a_bg-lg-focus-ring-color",
  "bg-lg-google": "Y1zP0a_bg-lg-google",
  "bg-lg-gray0": "Y1zP0a_bg-lg-gray0",
  "bg-lg-gray1": "Y1zP0a_bg-lg-gray1",
  "bg-lg-gray2": "Y1zP0a_bg-lg-gray2",
  "bg-lg-gray3": "Y1zP0a_bg-lg-gray3",
  "bg-lg-gray4": "Y1zP0a_bg-lg-gray4",
  "bg-lg-gray5": "Y1zP0a_bg-lg-gray5",
  "bg-lg-gray6": "Y1zP0a_bg-lg-gray6",
  "bg-lg-gray7": "Y1zP0a_bg-lg-gray7",
  "bg-lg-gray8": "Y1zP0a_bg-lg-gray8",
  "bg-lg-gray9": "Y1zP0a_bg-lg-gray9",
  "bg-lg-info": "Y1zP0a_bg-lg-info",
  "bg-lg-lightBlack": "Y1zP0a_bg-lg-lightBlack",
  "bg-lg-linkedin": "Y1zP0a_bg-lg-linkedin",
  "bg-lg-primary": "Y1zP0a_bg-lg-primary",
  "bg-lg-primaryLight": "Y1zP0a_bg-lg-primaryLight",
  "bg-lg-primaryVeryLight": "Y1zP0a_bg-lg-primaryVeryLight",
  "bg-lg-secondary": "Y1zP0a_bg-lg-secondary",
  "bg-lg-secondaryLight": "Y1zP0a_bg-lg-secondaryLight",
  "bg-lg-secondaryVeryLight": "Y1zP0a_bg-lg-secondaryVeryLight",
  "bg-lg-success": "Y1zP0a_bg-lg-success",
  "bg-lg-successLight": "Y1zP0a_bg-lg-successLight",
  "bg-lg-successVeryLight": "Y1zP0a_bg-lg-successVeryLight",
  "bg-lg-transparent": "Y1zP0a_bg-lg-transparent",
  "bg-lg-twitter": "Y1zP0a_bg-lg-twitter",
  "bg-lg-warning": "Y1zP0a_bg-lg-warning",
  "bg-lg-warningLight": "Y1zP0a_bg-lg-warningLight",
  "bg-lg-warningVeryLight": "Y1zP0a_bg-lg-warningVeryLight",
  "bg-lg-white": "Y1zP0a_bg-lg-white",
  "bg-lg-xing": "Y1zP0a_bg-lg-xing",
  "bg-md-background": "Y1zP0a_bg-md-background",
  "bg-md-black": "Y1zP0a_bg-md-black",
  "bg-md-danger": "Y1zP0a_bg-md-danger",
  "bg-md-dangerLight": "Y1zP0a_bg-md-dangerLight",
  "bg-md-dangerVeryLight": "Y1zP0a_bg-md-dangerVeryLight",
  "bg-md-default": "Y1zP0a_bg-md-default",
  "bg-md-facebook": "Y1zP0a_bg-md-facebook",
  "bg-md-featured": "Y1zP0a_bg-md-featured",
  "bg-md-featuredLight": "Y1zP0a_bg-md-featuredLight",
  "bg-md-featuredVeryLight": "Y1zP0a_bg-md-featuredVeryLight",
  "bg-md-focus-ring-color": "Y1zP0a_bg-md-focus-ring-color",
  "bg-md-google": "Y1zP0a_bg-md-google",
  "bg-md-gray0": "Y1zP0a_bg-md-gray0",
  "bg-md-gray1": "Y1zP0a_bg-md-gray1",
  "bg-md-gray2": "Y1zP0a_bg-md-gray2",
  "bg-md-gray3": "Y1zP0a_bg-md-gray3",
  "bg-md-gray4": "Y1zP0a_bg-md-gray4",
  "bg-md-gray5": "Y1zP0a_bg-md-gray5",
  "bg-md-gray6": "Y1zP0a_bg-md-gray6",
  "bg-md-gray7": "Y1zP0a_bg-md-gray7",
  "bg-md-gray8": "Y1zP0a_bg-md-gray8",
  "bg-md-gray9": "Y1zP0a_bg-md-gray9",
  "bg-md-info": "Y1zP0a_bg-md-info",
  "bg-md-lightBlack": "Y1zP0a_bg-md-lightBlack",
  "bg-md-linkedin": "Y1zP0a_bg-md-linkedin",
  "bg-md-primary": "Y1zP0a_bg-md-primary",
  "bg-md-primaryLight": "Y1zP0a_bg-md-primaryLight",
  "bg-md-primaryVeryLight": "Y1zP0a_bg-md-primaryVeryLight",
  "bg-md-secondary": "Y1zP0a_bg-md-secondary",
  "bg-md-secondaryLight": "Y1zP0a_bg-md-secondaryLight",
  "bg-md-secondaryVeryLight": "Y1zP0a_bg-md-secondaryVeryLight",
  "bg-md-success": "Y1zP0a_bg-md-success",
  "bg-md-successLight": "Y1zP0a_bg-md-successLight",
  "bg-md-successVeryLight": "Y1zP0a_bg-md-successVeryLight",
  "bg-md-transparent": "Y1zP0a_bg-md-transparent",
  "bg-md-twitter": "Y1zP0a_bg-md-twitter",
  "bg-md-warning": "Y1zP0a_bg-md-warning",
  "bg-md-warningLight": "Y1zP0a_bg-md-warningLight",
  "bg-md-warningVeryLight": "Y1zP0a_bg-md-warningVeryLight",
  "bg-md-white": "Y1zP0a_bg-md-white",
  "bg-md-xing": "Y1zP0a_bg-md-xing",
  "bg-sm-background": "Y1zP0a_bg-sm-background",
  "bg-sm-black": "Y1zP0a_bg-sm-black",
  "bg-sm-danger": "Y1zP0a_bg-sm-danger",
  "bg-sm-dangerLight": "Y1zP0a_bg-sm-dangerLight",
  "bg-sm-dangerVeryLight": "Y1zP0a_bg-sm-dangerVeryLight",
  "bg-sm-default": "Y1zP0a_bg-sm-default",
  "bg-sm-facebook": "Y1zP0a_bg-sm-facebook",
  "bg-sm-featured": "Y1zP0a_bg-sm-featured",
  "bg-sm-featuredLight": "Y1zP0a_bg-sm-featuredLight",
  "bg-sm-featuredVeryLight": "Y1zP0a_bg-sm-featuredVeryLight",
  "bg-sm-focus-ring-color": "Y1zP0a_bg-sm-focus-ring-color",
  "bg-sm-google": "Y1zP0a_bg-sm-google",
  "bg-sm-gray0": "Y1zP0a_bg-sm-gray0",
  "bg-sm-gray1": "Y1zP0a_bg-sm-gray1",
  "bg-sm-gray2": "Y1zP0a_bg-sm-gray2",
  "bg-sm-gray3": "Y1zP0a_bg-sm-gray3",
  "bg-sm-gray4": "Y1zP0a_bg-sm-gray4",
  "bg-sm-gray5": "Y1zP0a_bg-sm-gray5",
  "bg-sm-gray6": "Y1zP0a_bg-sm-gray6",
  "bg-sm-gray7": "Y1zP0a_bg-sm-gray7",
  "bg-sm-gray8": "Y1zP0a_bg-sm-gray8",
  "bg-sm-gray9": "Y1zP0a_bg-sm-gray9",
  "bg-sm-info": "Y1zP0a_bg-sm-info",
  "bg-sm-lightBlack": "Y1zP0a_bg-sm-lightBlack",
  "bg-sm-linkedin": "Y1zP0a_bg-sm-linkedin",
  "bg-sm-primary": "Y1zP0a_bg-sm-primary",
  "bg-sm-primaryLight": "Y1zP0a_bg-sm-primaryLight",
  "bg-sm-primaryVeryLight": "Y1zP0a_bg-sm-primaryVeryLight",
  "bg-sm-secondary": "Y1zP0a_bg-sm-secondary",
  "bg-sm-secondaryLight": "Y1zP0a_bg-sm-secondaryLight",
  "bg-sm-secondaryVeryLight": "Y1zP0a_bg-sm-secondaryVeryLight",
  "bg-sm-success": "Y1zP0a_bg-sm-success",
  "bg-sm-successLight": "Y1zP0a_bg-sm-successLight",
  "bg-sm-successVeryLight": "Y1zP0a_bg-sm-successVeryLight",
  "bg-sm-transparent": "Y1zP0a_bg-sm-transparent",
  "bg-sm-twitter": "Y1zP0a_bg-sm-twitter",
  "bg-sm-warning": "Y1zP0a_bg-sm-warning",
  "bg-sm-warningLight": "Y1zP0a_bg-sm-warningLight",
  "bg-sm-warningVeryLight": "Y1zP0a_bg-sm-warningVeryLight",
  "bg-sm-white": "Y1zP0a_bg-sm-white",
  "bg-sm-xing": "Y1zP0a_bg-sm-xing",
  "bg-xl-background": "Y1zP0a_bg-xl-background",
  "bg-xl-black": "Y1zP0a_bg-xl-black",
  "bg-xl-danger": "Y1zP0a_bg-xl-danger",
  "bg-xl-dangerLight": "Y1zP0a_bg-xl-dangerLight",
  "bg-xl-dangerVeryLight": "Y1zP0a_bg-xl-dangerVeryLight",
  "bg-xl-default": "Y1zP0a_bg-xl-default",
  "bg-xl-facebook": "Y1zP0a_bg-xl-facebook",
  "bg-xl-featured": "Y1zP0a_bg-xl-featured",
  "bg-xl-featuredLight": "Y1zP0a_bg-xl-featuredLight",
  "bg-xl-featuredVeryLight": "Y1zP0a_bg-xl-featuredVeryLight",
  "bg-xl-focus-ring-color": "Y1zP0a_bg-xl-focus-ring-color",
  "bg-xl-google": "Y1zP0a_bg-xl-google",
  "bg-xl-gray0": "Y1zP0a_bg-xl-gray0",
  "bg-xl-gray1": "Y1zP0a_bg-xl-gray1",
  "bg-xl-gray2": "Y1zP0a_bg-xl-gray2",
  "bg-xl-gray3": "Y1zP0a_bg-xl-gray3",
  "bg-xl-gray4": "Y1zP0a_bg-xl-gray4",
  "bg-xl-gray5": "Y1zP0a_bg-xl-gray5",
  "bg-xl-gray6": "Y1zP0a_bg-xl-gray6",
  "bg-xl-gray7": "Y1zP0a_bg-xl-gray7",
  "bg-xl-gray8": "Y1zP0a_bg-xl-gray8",
  "bg-xl-gray9": "Y1zP0a_bg-xl-gray9",
  "bg-xl-info": "Y1zP0a_bg-xl-info",
  "bg-xl-lightBlack": "Y1zP0a_bg-xl-lightBlack",
  "bg-xl-linkedin": "Y1zP0a_bg-xl-linkedin",
  "bg-xl-primary": "Y1zP0a_bg-xl-primary",
  "bg-xl-primaryLight": "Y1zP0a_bg-xl-primaryLight",
  "bg-xl-primaryVeryLight": "Y1zP0a_bg-xl-primaryVeryLight",
  "bg-xl-secondary": "Y1zP0a_bg-xl-secondary",
  "bg-xl-secondaryLight": "Y1zP0a_bg-xl-secondaryLight",
  "bg-xl-secondaryVeryLight": "Y1zP0a_bg-xl-secondaryVeryLight",
  "bg-xl-success": "Y1zP0a_bg-xl-success",
  "bg-xl-successLight": "Y1zP0a_bg-xl-successLight",
  "bg-xl-successVeryLight": "Y1zP0a_bg-xl-successVeryLight",
  "bg-xl-transparent": "Y1zP0a_bg-xl-transparent",
  "bg-xl-twitter": "Y1zP0a_bg-xl-twitter",
  "bg-xl-warning": "Y1zP0a_bg-xl-warning",
  "bg-xl-warningLight": "Y1zP0a_bg-xl-warningLight",
  "bg-xl-warningVeryLight": "Y1zP0a_bg-xl-warningVeryLight",
  "bg-xl-white": "Y1zP0a_bg-xl-white",
  "bg-xl-xing": "Y1zP0a_bg-xl-xing",
  "color-lg-background": "Y1zP0a_color-lg-background",
  "color-lg-black": "Y1zP0a_color-lg-black",
  "color-lg-danger": "Y1zP0a_color-lg-danger",
  "color-lg-dangerLight": "Y1zP0a_color-lg-dangerLight",
  "color-lg-dangerVeryLight": "Y1zP0a_color-lg-dangerVeryLight",
  "color-lg-default": "Y1zP0a_color-lg-default",
  "color-lg-facebook": "Y1zP0a_color-lg-facebook",
  "color-lg-featured": "Y1zP0a_color-lg-featured",
  "color-lg-featuredLight": "Y1zP0a_color-lg-featuredLight",
  "color-lg-featuredVeryLight": "Y1zP0a_color-lg-featuredVeryLight",
  "color-lg-focus-ring-color": "Y1zP0a_color-lg-focus-ring-color",
  "color-lg-google": "Y1zP0a_color-lg-google",
  "color-lg-gray0": "Y1zP0a_color-lg-gray0",
  "color-lg-gray1": "Y1zP0a_color-lg-gray1",
  "color-lg-gray2": "Y1zP0a_color-lg-gray2",
  "color-lg-gray3": "Y1zP0a_color-lg-gray3",
  "color-lg-gray4": "Y1zP0a_color-lg-gray4",
  "color-lg-gray5": "Y1zP0a_color-lg-gray5",
  "color-lg-gray6": "Y1zP0a_color-lg-gray6",
  "color-lg-gray7": "Y1zP0a_color-lg-gray7",
  "color-lg-gray8": "Y1zP0a_color-lg-gray8",
  "color-lg-gray9": "Y1zP0a_color-lg-gray9",
  "color-lg-info": "Y1zP0a_color-lg-info",
  "color-lg-lightBlack": "Y1zP0a_color-lg-lightBlack",
  "color-lg-linkedin": "Y1zP0a_color-lg-linkedin",
  "color-lg-primary": "Y1zP0a_color-lg-primary",
  "color-lg-primaryLight": "Y1zP0a_color-lg-primaryLight",
  "color-lg-primaryVeryLight": "Y1zP0a_color-lg-primaryVeryLight",
  "color-lg-secondary": "Y1zP0a_color-lg-secondary",
  "color-lg-secondaryLight": "Y1zP0a_color-lg-secondaryLight",
  "color-lg-secondaryVeryLight": "Y1zP0a_color-lg-secondaryVeryLight",
  "color-lg-success": "Y1zP0a_color-lg-success",
  "color-lg-successLight": "Y1zP0a_color-lg-successLight",
  "color-lg-successVeryLight": "Y1zP0a_color-lg-successVeryLight",
  "color-lg-transparent": "Y1zP0a_color-lg-transparent",
  "color-lg-twitter": "Y1zP0a_color-lg-twitter",
  "color-lg-warning": "Y1zP0a_color-lg-warning",
  "color-lg-warningLight": "Y1zP0a_color-lg-warningLight",
  "color-lg-warningVeryLight": "Y1zP0a_color-lg-warningVeryLight",
  "color-lg-white": "Y1zP0a_color-lg-white",
  "color-lg-xing": "Y1zP0a_color-lg-xing",
  "color-md-background": "Y1zP0a_color-md-background",
  "color-md-black": "Y1zP0a_color-md-black",
  "color-md-danger": "Y1zP0a_color-md-danger",
  "color-md-dangerLight": "Y1zP0a_color-md-dangerLight",
  "color-md-dangerVeryLight": "Y1zP0a_color-md-dangerVeryLight",
  "color-md-default": "Y1zP0a_color-md-default",
  "color-md-facebook": "Y1zP0a_color-md-facebook",
  "color-md-featured": "Y1zP0a_color-md-featured",
  "color-md-featuredLight": "Y1zP0a_color-md-featuredLight",
  "color-md-featuredVeryLight": "Y1zP0a_color-md-featuredVeryLight",
  "color-md-focus-ring-color": "Y1zP0a_color-md-focus-ring-color",
  "color-md-google": "Y1zP0a_color-md-google",
  "color-md-gray0": "Y1zP0a_color-md-gray0",
  "color-md-gray1": "Y1zP0a_color-md-gray1",
  "color-md-gray2": "Y1zP0a_color-md-gray2",
  "color-md-gray3": "Y1zP0a_color-md-gray3",
  "color-md-gray4": "Y1zP0a_color-md-gray4",
  "color-md-gray5": "Y1zP0a_color-md-gray5",
  "color-md-gray6": "Y1zP0a_color-md-gray6",
  "color-md-gray7": "Y1zP0a_color-md-gray7",
  "color-md-gray8": "Y1zP0a_color-md-gray8",
  "color-md-gray9": "Y1zP0a_color-md-gray9",
  "color-md-info": "Y1zP0a_color-md-info",
  "color-md-lightBlack": "Y1zP0a_color-md-lightBlack",
  "color-md-linkedin": "Y1zP0a_color-md-linkedin",
  "color-md-primary": "Y1zP0a_color-md-primary",
  "color-md-primaryLight": "Y1zP0a_color-md-primaryLight",
  "color-md-primaryVeryLight": "Y1zP0a_color-md-primaryVeryLight",
  "color-md-secondary": "Y1zP0a_color-md-secondary",
  "color-md-secondaryLight": "Y1zP0a_color-md-secondaryLight",
  "color-md-secondaryVeryLight": "Y1zP0a_color-md-secondaryVeryLight",
  "color-md-success": "Y1zP0a_color-md-success",
  "color-md-successLight": "Y1zP0a_color-md-successLight",
  "color-md-successVeryLight": "Y1zP0a_color-md-successVeryLight",
  "color-md-transparent": "Y1zP0a_color-md-transparent",
  "color-md-twitter": "Y1zP0a_color-md-twitter",
  "color-md-warning": "Y1zP0a_color-md-warning",
  "color-md-warningLight": "Y1zP0a_color-md-warningLight",
  "color-md-warningVeryLight": "Y1zP0a_color-md-warningVeryLight",
  "color-md-white": "Y1zP0a_color-md-white",
  "color-md-xing": "Y1zP0a_color-md-xing",
  "color-sm-background": "Y1zP0a_color-sm-background",
  "color-sm-black": "Y1zP0a_color-sm-black",
  "color-sm-danger": "Y1zP0a_color-sm-danger",
  "color-sm-dangerLight": "Y1zP0a_color-sm-dangerLight",
  "color-sm-dangerVeryLight": "Y1zP0a_color-sm-dangerVeryLight",
  "color-sm-default": "Y1zP0a_color-sm-default",
  "color-sm-facebook": "Y1zP0a_color-sm-facebook",
  "color-sm-featured": "Y1zP0a_color-sm-featured",
  "color-sm-featuredLight": "Y1zP0a_color-sm-featuredLight",
  "color-sm-featuredVeryLight": "Y1zP0a_color-sm-featuredVeryLight",
  "color-sm-focus-ring-color": "Y1zP0a_color-sm-focus-ring-color",
  "color-sm-google": "Y1zP0a_color-sm-google",
  "color-sm-gray0": "Y1zP0a_color-sm-gray0",
  "color-sm-gray1": "Y1zP0a_color-sm-gray1",
  "color-sm-gray2": "Y1zP0a_color-sm-gray2",
  "color-sm-gray3": "Y1zP0a_color-sm-gray3",
  "color-sm-gray4": "Y1zP0a_color-sm-gray4",
  "color-sm-gray5": "Y1zP0a_color-sm-gray5",
  "color-sm-gray6": "Y1zP0a_color-sm-gray6",
  "color-sm-gray7": "Y1zP0a_color-sm-gray7",
  "color-sm-gray8": "Y1zP0a_color-sm-gray8",
  "color-sm-gray9": "Y1zP0a_color-sm-gray9",
  "color-sm-info": "Y1zP0a_color-sm-info",
  "color-sm-lightBlack": "Y1zP0a_color-sm-lightBlack",
  "color-sm-linkedin": "Y1zP0a_color-sm-linkedin",
  "color-sm-primary": "Y1zP0a_color-sm-primary",
  "color-sm-primaryLight": "Y1zP0a_color-sm-primaryLight",
  "color-sm-primaryVeryLight": "Y1zP0a_color-sm-primaryVeryLight",
  "color-sm-secondary": "Y1zP0a_color-sm-secondary",
  "color-sm-secondaryLight": "Y1zP0a_color-sm-secondaryLight",
  "color-sm-secondaryVeryLight": "Y1zP0a_color-sm-secondaryVeryLight",
  "color-sm-success": "Y1zP0a_color-sm-success",
  "color-sm-successLight": "Y1zP0a_color-sm-successLight",
  "color-sm-successVeryLight": "Y1zP0a_color-sm-successVeryLight",
  "color-sm-transparent": "Y1zP0a_color-sm-transparent",
  "color-sm-twitter": "Y1zP0a_color-sm-twitter",
  "color-sm-warning": "Y1zP0a_color-sm-warning",
  "color-sm-warningLight": "Y1zP0a_color-sm-warningLight",
  "color-sm-warningVeryLight": "Y1zP0a_color-sm-warningVeryLight",
  "color-sm-white": "Y1zP0a_color-sm-white",
  "color-sm-xing": "Y1zP0a_color-sm-xing",
  "color-xl-background": "Y1zP0a_color-xl-background",
  "color-xl-black": "Y1zP0a_color-xl-black",
  "color-xl-danger": "Y1zP0a_color-xl-danger",
  "color-xl-dangerLight": "Y1zP0a_color-xl-dangerLight",
  "color-xl-dangerVeryLight": "Y1zP0a_color-xl-dangerVeryLight",
  "color-xl-default": "Y1zP0a_color-xl-default",
  "color-xl-facebook": "Y1zP0a_color-xl-facebook",
  "color-xl-featured": "Y1zP0a_color-xl-featured",
  "color-xl-featuredLight": "Y1zP0a_color-xl-featuredLight",
  "color-xl-featuredVeryLight": "Y1zP0a_color-xl-featuredVeryLight",
  "color-xl-focus-ring-color": "Y1zP0a_color-xl-focus-ring-color",
  "color-xl-google": "Y1zP0a_color-xl-google",
  "color-xl-gray0": "Y1zP0a_color-xl-gray0",
  "color-xl-gray1": "Y1zP0a_color-xl-gray1",
  "color-xl-gray2": "Y1zP0a_color-xl-gray2",
  "color-xl-gray3": "Y1zP0a_color-xl-gray3",
  "color-xl-gray4": "Y1zP0a_color-xl-gray4",
  "color-xl-gray5": "Y1zP0a_color-xl-gray5",
  "color-xl-gray6": "Y1zP0a_color-xl-gray6",
  "color-xl-gray7": "Y1zP0a_color-xl-gray7",
  "color-xl-gray8": "Y1zP0a_color-xl-gray8",
  "color-xl-gray9": "Y1zP0a_color-xl-gray9",
  "color-xl-info": "Y1zP0a_color-xl-info",
  "color-xl-lightBlack": "Y1zP0a_color-xl-lightBlack",
  "color-xl-linkedin": "Y1zP0a_color-xl-linkedin",
  "color-xl-primary": "Y1zP0a_color-xl-primary",
  "color-xl-primaryLight": "Y1zP0a_color-xl-primaryLight",
  "color-xl-primaryVeryLight": "Y1zP0a_color-xl-primaryVeryLight",
  "color-xl-secondary": "Y1zP0a_color-xl-secondary",
  "color-xl-secondaryLight": "Y1zP0a_color-xl-secondaryLight",
  "color-xl-secondaryVeryLight": "Y1zP0a_color-xl-secondaryVeryLight",
  "color-xl-success": "Y1zP0a_color-xl-success",
  "color-xl-successLight": "Y1zP0a_color-xl-successLight",
  "color-xl-successVeryLight": "Y1zP0a_color-xl-successVeryLight",
  "color-xl-transparent": "Y1zP0a_color-xl-transparent",
  "color-xl-twitter": "Y1zP0a_color-xl-twitter",
  "color-xl-warning": "Y1zP0a_color-xl-warning",
  "color-xl-warningLight": "Y1zP0a_color-xl-warningLight",
  "color-xl-warningVeryLight": "Y1zP0a_color-xl-warningVeryLight",
  "color-xl-white": "Y1zP0a_color-xl-white",
  "color-xl-xing": "Y1zP0a_color-xl-xing",
  "flatBanner": "Y1zP0a_flatBanner",
  "flatBannerText": "Y1zP0a_flatBannerText",
});
